import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@services/api"; // Same api client used elsewhere

export const useSortingStateQuery = () => {
  return useQuery({
    queryKey: ["sorting_state"],
    queryFn: async () => {
      const { data } = await api.get("/sorting/state");
      return data.dividers || [];
    },
    refetchInterval: 10000,
  });
};

export const useLoadOrderMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (orderId) => {
      const { data } = await api.get(`/sorting/order/${orderId}`);
      return data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["sorting_state"] });
    }
  });
};

export const useSortItemMutation = () => {
  return useMutation({
    mutationFn: async (orderProductId) => {
      const { data } = await api.post(`/sorting/item/${orderProductId}/sort`);
      return data;
    }
  });
};

export const useUnSortItemMutation = () => {
  return useMutation({
    mutationFn: async (orderProductId) => {
      const { data } = await api.post(`/sorting/item/${orderProductId}/unsort`);
      return data;
    }
  });
};

export const useChangeDividerMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, divider_number }) => {
      const { data } = await api.post(`/sorting/order/${orderId}/divider`, { divider_number });
      return data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["sorting_state"] });
    }
  });
};

export const useEmptyDividerMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (number) => {
      const { data } = await api.post(`/sorting/divider/${number}/empty`);
      return data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["sorting_state"] });
    }
  });
};

export const useEmptyAllMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data } = await api.post(`/sorting/empty-all`);
      return data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["sorting_state"] });
    }
  });
};
